// Piccolo aiuto per creare elementi senza framework. Il testo passa sempre da textContent (mai innerHTML):
// i dati arrivano da fonti esterne e non devono poter iniettare HTML.

type Figlio = Node | string | number | null | undefined | false;
type Attributi = Record<string, string | number | boolean | null | undefined | ((e: Event) => void)>;

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attr: Attributi | null = null,
  ...figli: (Figlio | Figlio[])[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (attr) {
    for (const [k, v] of Object.entries(attr)) {
      if (v === null || v === undefined || v === false) continue;
      if (typeof v === 'function') el.addEventListener(k.replace(/^on/, '').toLowerCase(), v as EventListener);
      else if (k === 'class') el.className = String(v);
      else if (v === true) el.setAttribute(k, '');
      else el.setAttribute(k, String(v));
    }
  }
  aggiungi(el, figli);
  return el;
}

export function aggiungi(el: Element, figli: (Figlio | Figlio[])[]): void {
  for (const f of figli.flat()) {
    if (f === null || f === undefined || f === false) continue;
    el.append(f instanceof Node ? f : document.createTextNode(String(f)));
  }
}

/** Icona dal set in index.html (<symbol id="i-…">). */
export function icona(nome: string, classe = 'icona'): SVGSVGElement {
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('class', classe);
  svg.setAttribute('aria-hidden', 'true');
  const use = document.createElementNS(ns, 'use');
  use.setAttribute('href', `#i-${nome}`);
  svg.append(use);
  return svg;
}

/** Card di vetro: un elemento con data-vetro che lo shader trasforma in lastra. */
export function vetro<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attr: Attributi | null,
  ...figli: (Figlio | Figlio[])[]
): HTMLElementTagNameMap[K] {
  const el = h(tag, { ...attr, 'data-vetro': true }, ...figli);
  el.classList.add('vetro');
  return el;
}
